import React, { useContext, useEffect, useState } from 'react';
import { Form, Field } from '@progress/kendo-react-form';
import { Grid } from '@mui/material';
import Stack from '@mui/material/Stack';
import { UiButton } from '../../../../_uiComponents/common/form/UiButton';
import UiInput from '../../../../_uiComponents/telerikComponents/UiInput';
import { UiSwitch } from '../../../../_uiComponents/telerikComponents/UiSwitch';
import { useDispatch } from 'react-redux';
import { Context } from '../../../../../_context/Store';
import { contextApiActions } from '../../../../../_redux/_constants';
import { participantActiveParticipantRequest } from '../../../../../_redux/_actions';

export default function SendActivationEmail(props) {
    const actionDispatch = useDispatch();
    const [isChecked, setIsChecked] = useState(false);
    const [state, dispatch] = useContext(Context);

    const emailRegex = /\S+@\S+\.\S+/;
    const emailValidator = (value) => {
        if (isChecked) {
            return !value
                ? 'Email is required.'
                : emailRegex.test(value)
                ? ''
                : 'Email is not in a valid format.';
        }
        return ''; // No validation when switch is off
    };

    const handleSubmit = (dataItem) => {
        actionDispatch(
            participantActiveParticipantRequest({
                ParticipantId: props.data.id,
                SendToSecondaryEmail: isChecked,
                SecondaryEmail: isChecked ? dataItem.email : undefined,
            })
        );

        dispatch({
            type: contextApiActions.UI_MODAL_TOGGEL,
            payload: {
                show: false,
            },
        });
    };

    const handleSave = (formRenderProps) => {
        if (!isChecked) {
            handleSubmit({});
        } else {
            formRenderProps.onSubmit();
        }
    };

    return (
        <Form
            onSubmit={handleSubmit}
            render={(formRenderProps) => (
                <div className="sba-telerik-components-wr">
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                            <Field
                                name="status"
                                component={UiSwitch}
                                labelClassName="k-form-label"
                                handleChange={setIsChecked}
                                isChecked={isChecked}
                                label="Send to Secondary Email"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        {isChecked && (
                            <Grid item xs={12} lg={8} sx={{ mt: 2 }}>
                                <Field
                                    name="email"
                                    validator={emailValidator}
                                    component={UiInput}
                                    labelClassName="k-form-label"
                                    label="Secondary Email"
                                />
                            </Grid>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <Stack
                            spacing={2}
                            direction="row"
                            justifyContent="end"
                            sx={{ width: '100%', mt: 1.5 }}
                        >
                            <div className="sbt-right-action-btn-wr">
                                <UiButton
                                    name="Cancel"
                                    variant="outlined"
                                    size="small"
                                    onClick={() => {
                                        formRenderProps.onFormReset();
                                        dispatch({
                                            type: contextApiActions.UI_MODAL_TOGGEL,
                                            payload: {
                                                show: false,
                                            },
                                        });
                                    }}
                                />
                                <UiButton
                                    name="Save"
                                    variant="contained"
                                    size="small"
                                    onClick={() => handleSave(formRenderProps)}
                                />
                            </div>
                        </Stack>
                    </Grid>
                </div>
            )}
        />
    );
}
